// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"commonStyles_sectionWrapper__3XoED","title":"commonStyles_title__3ANul","withRoundedBorder":"commonStyles_withRoundedBorder__2mRw7"};